import { faker } from '@faker-js/faker';
import { array, define } from 'cooky-cutter';
import {
  Device,
  DeviceData,
  DeviceDetailsTableRow,
  DeviceForSoftwareAssignmentGroup,
  DeviceRegistrationStatus,
  DeviceStatus,
  GroupCode,
  RegistrationFileDevicesTableRow,
} from '../types';
import { deviceModelFactory } from './device-models';
import { salesOrderLineFactory } from './sales-order-lines';
import { salesOrderFactory } from './sales-orders';
import { serialNumberFactory } from './serial-numbers';
import { deviceGroupFactory } from './work-orders';

export const deviceFactory = define<Device>({
  id: () => faker.string.uuid(),
  externalId: () => faker.string.numeric({ length: 10 }),
  status: () => DeviceStatus.ACTIVE,
  model: deviceModelFactory,
  serialNumber: serialNumberFactory,
  salesOrderLine: salesOrderLineFactory,
  assignments: () => [],
  deviceRegistrationRequest: () => [],
  deviceRegistration: () => [],
  defaultName: () => '',
});

export const deviceDataFactory = define<DeviceData>({
  id: () => faker.string.uuid(),
  model: () => deviceModelFactory(),
  serialNumber: () => serialNumberFactory(),
  salesOrder: () => ({
    id: faker.string.uuid(),
    number: faker.number.int(),
    endUser: faker.internet.email().toLocaleLowerCase(),
  }),
  defaultName: () => '',
  hasOriginalConfiguration: () => faker.datatype.boolean(),
});

export const groupCodeFactory = define<GroupCode>({
  code: () => faker.string.alphanumeric({ length: 8 }),
  deviceGroup: () => deviceGroupFactory(),
});

export const deviceForSoftwareAssignmentGroupFactory =
  define<DeviceForSoftwareAssignmentGroup>({
    id: () => faker.string.uuid(),
    name: () => faker.lorem.word({ strategy: 'any-length' }),
    devices: array(deviceFactory, 3),
    groupCode: () => groupCodeFactory(),
    creator: () => faker.string.uuid(),
  });

export const registrationFileDevicesTableRowFactory =
  define<RegistrationFileDevicesTableRow>({
    id: () => faker.string.uuid(),
    serialNumber: () => faker.string.uuid(),
    name: () => faker.lorem.word({ strategy: 'any-length' }),
    type: () => faker.lorem.word(3),
    status: () => faker.helpers.enumValue(DeviceRegistrationStatus),
    registrations: () => [],
    salesOrder: () => salesOrderFactory(),
  });

export const deviceDetailsTableRowFactory = define<DeviceDetailsTableRow>({
  serialNumber: () => faker.string.alphanumeric({ length: 8 }),
  deviceType: () => faker.lorem.word({ strategy: 'any-length' }),
  inventoryLocation: () => 'Genesis',
});
